module.exports = function() {
  return new Worker(__webpack_public_path__ + "eb244ba2c7c36bc4db0e.worker.js");
};